// Cashier Transactions Mutations

export const updateTransactionsList = (state, payload) => {
  state.transactionsList = payload
}

export const setTransactionInfo = (state, payload) => {
  state.transactionInfo = payload
}
